import { BREAKPOINTS, LOCALES } from '../metadata/types.js';
import { getBreakpointProps } from './get-breakpoint-props.js';
import { getLocaleProps } from './get-locale-props.js';
function resolveProps(props, breakpoint = '', locale = '') {
    const breakpointProps = getBreakpointProps(props, breakpoint);
    const localeProps = getLocaleProps(props, locale);
    const localeBreakpointProps = getBreakpointProps(localeProps, breakpoint);
    const defaultProps = { ...props };
    deleteScopedProperties(defaultProps, [BREAKPOINTS, LOCALES]);
    deleteScopedProperties(localeProps, [BREAKPOINTS]);
    return {
        ...defaultProps,
        ...breakpointProps,
        ...localeProps,
        ...localeBreakpointProps,
    };
}
function deleteScopedProperties(props, scopes) {
    scopes.forEach((scope) => {
        delete props[scope];
    });
}
export { resolveProps, };
//# sourceMappingURL=resolve-props.js.map